import { useBoundStore } from '@Store/useBoundStore';
import { OnboardingFormFields } from '@Types/index';
import type { IRegisteredAddressForm } from '../registeredAddressForm/registeredAddressSchema';

export const syncRegisteredAddress = (input: IRegisteredAddressForm) => {
  const { getCustomerData, setCustomerData } = useBoundStore.getState();
  const customerDataToUpdate = getCustomerData();
  setCustomerData({
    ...customerDataToUpdate,
    customerData: {
      ...customerDataToUpdate.customerData,
      registeredBusinessAddressData: {
        line1: input[OnboardingFormFields.LINE1] ?? '',
        line2: input[OnboardingFormFields.APARTMENT] ?? '',
        city: input[OnboardingFormFields.CITY] ?? '',
        state: input[OnboardingFormFields.STATE]?.value ?? '',
        postalCode: input[OnboardingFormFields.ZIP] ?? '',
        country: 'US',
        sameAsPrimary: false,
      },
    },
  });
};
